import React, { FunctionComponent } from 'react';

type Props = {
    type: string;
    id: string;
};
export const FBComments: FunctionComponent<Props> = ({ type, id }) => {
    return (
        <div className='container pb-4 pt-4'>
            <div className='row'>
                <div
                    className='fb-comments'
                    data-href={`${process.env.NEXT_PUBLIC_WEBSITE_URL}/${type}/${id}`}
                    data-width='100%'
                    data-numposts='5'></div>
            </div>
        </div>
    );
};
